
        export const CometChatSettings = {
  "chatFeatures": {
    "coreMessagingExperience": {
      "typingIndicator": true,
      "threadConversationAndReplies": true,
      "photosSharing": true,
      "videoSharing": true,
      "audioSharing": true,
      "fileSharing": true,
      "editMessage": true,
      "deleteMessage": true,
      "messageDeliveryAndReadReceipts": true,
      "userAndFriendsPresence": true,
      "conversationAndAdvancedSearch": true,
      "moderation": true,
      "quotedReplies": false,
      "markAsUnread": false,
      "richTextFormatting": true
    },
    "deeperUserEngagement": {
      "mentions": true,
      "mentionAll": true,
      "reactions": true,
      "messageTranslation": true,
      "polls": true,
      "collaborativeWhiteboard": false,
      "collaborativeDocument": false,
      "voiceNotes": true,
      "emojis": true,
      "stickers": true,
      "userInfo": true,
      "groupInfo": true
    },
    "aiUserCopilot": {
      "conversationStarter": false,
      "conversationSummary": false,
      "smartReply": false
    },
    "userManagement": {
      "friendsOnly": false
    },
    "groupManagement": {
      "createGroup": true,
      "addMembersToGroups": true,
      "joinLeaveGroup": true,
      "deleteGroup": true,
      "viewGroupMembers": true
    },
    "moderatorControls": {
      "kickUsers": true,
      "banUsers": true,
      "promoteDemoteMembers": true,
      "reportMessage": true
    },
    "privateMessagingWithinGroups": {
      "sendPrivateMessageToGroupMembers": true
    },
    "inAppSounds": {
      "incomingMessageSound": false,
      "outgoingMessageSound": false
    }
  },
  "callFeatures": {
    "voiceAndVideoCalling": {
      "oneOnOneVoiceCalling": false,
      "oneOnOneVideoCalling": false,
      "groupVideoConference": false,
      "groupVoiceConference": false
    }
  },
  "layout": {
    "withSideBar": true,
    "tabs": [
      "chats",
      "users",
      "groups"
    ],
    "chatType": "user",
    "compactMessageComposer": false
  },
  "style": {
    "theme": "light",
    "color": {
      "brandColor": "#260e00",
      "primaryTextLight": "#260e00",
      "primaryTextDark": "#FFFFFF",
      "secondaryTextLight": "#727272",
      "secondaryTextDark": "#989898"
    },
    "typography": {
      "font": "\"Academy\", system-ui, -apple-system, sans-serif",
      "size": "comfortable"
    }
  },
  "noCode": {
    "docked": false,
    "styles": {
      "buttonBackGround": "#260e00",
      "buttonShape": "rounded",
      "openIcon": "https://cdn.shopify.com/s/files/1/0677/2647/5492/files/Redan_Chequy_1_sq.webp?v=1770941679",
      "closeIcon": "https://cdn.jsdelivr.net/npm/@cometchat/chat-embed@latest/dist/icons/docked_close_icon.svg",
      "customJs": "",
      "customCss": "",
      "dockedAlignment": "left"
    }
  },
  "agent": {
    "chatHistory": true,
    "newChat": true,
    "agentIcon": "",
    "showAgentIcon": true
  }
};
      